export const ACCOUNT_SELECTION_MODAL = {
  STAGING: {
    e1: [],
    e2: ['en-GB'],
  },
  'CONSUMER-TRAVEL': {
    e2: [],
  },
  'TRAVEL-ISEATZ': {
    e1: ['en-GB'],
    e2: ['en-GB'],
  },
};
